module.exports = __webpack_public_path__ + "media/brands/img1-d4015dec.jpg";